/**
 * View component for /user-nodes/:userNodeId
 *
 * Displays a single userNode from the 'byId' map in the userNode reducer
 * as defined by the 'selected' property
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as userNodeActions from '../userNodeActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import userNode components
import UserNodeLayout from '../components/UserNodeLayout.js.jsx';

// import userNode css modules
import userNodeStyles from '../userNodeModuleStyles.css';


class SingleUserNode extends Base {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userNodeActions.fetchSingleIfNeeded(match.params.userNodeId));
  }

  render() {
    const { userNodeStore } = this.props;

    /**
     * use the selected.getItem() utility to pull the actual userNode object from the map
     */
    const selectedUserNode = userNodeStore.selected.getItem();

    const isEmpty = (
      !selectedUserNode
      || !selectedUserNode._id
      || userNodeStore.selected.didInvalidate
    );

    return (
      <UserNodeLayout>
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h3> Single User Node </h3>
              {isEmpty ?
                (userNodeStore.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: userNodeStore.isFetching ? 0.5 : 1 }}>
                  <h1> { selectedUserNode.name }
                    <Link className="yt-btn small u-pullRight" to={`${this.props.match.url}/update`}> UPDATE User Node </Link>
                  </h1>
                  <hr/>
                  <p> <em>Other characteristics about the UserNode would go here.</em></p>
                </div>
              }
            </div>
          </section>
        </div>
      </UserNodeLayout>
    )
  }
}

SingleUserNode.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    userNodeStore: store.userNode
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(SingleUserNode)
);



// WEBPACK FOOTER //
// modules/userNode/views/SingleUserNode.js.jsx